const removeYearFromModelName = (year?: string, modelName?: string) => {
  let name = modelName;
  if (modelName && modelName.includes(`${year}`)) {
    const yearRemoved = modelName?.split(' ');
    yearRemoved.shift();
    name = yearRemoved.join(' ');
  }
  return name;
};

export default removeYearFromModelName;
